import { render, staticRenderFns } from "./openTxPair.vue?vue&type=template&id=073d78e8&"
import script from "./openTxPair.vue?vue&type=script&lang=js&"
export * from "./openTxPair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('073d78e8')) {
      api.createRecord('073d78e8', component.options)
    } else {
      api.reload('073d78e8', component.options)
    }
    module.hot.accept("./openTxPair.vue?vue&type=template&id=073d78e8&", function () {
      api.rerender('073d78e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/txPairManage/openTxPair.vue"
export default component.exports